const Category = [
  "Segmenters",
  "Lymphocytes",
  "Monocytes",
  "Eosinophils",
  "Stabs",
  "Basophils",
];

export default Category;
